<template>
  <el-dialog
      :visible.sync="visible"
      title="农村产权交易委托合同"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      @close="handleClose"
  >
      <div class="content">
        <h2>广西捷算资产交易市场服务有限公司</h2>
        <h1>农村产权交易委托合同</h1>
        <p>委托方名称：{{contractData.mainPartIdentityName}} </p>
        <p>{{contractData.createDate}}</p>
        <h2>广西捷算资产交易市场服务有限公司   制</h2>
        <h2>地址：广西百色市右江区城北二路18-1号4#</h2>
        <h2>联系电话：0776-2802868</h2>
        <h2>邮编：533000</h2>
        <p>合同使用须知</p>
        <p>一、本合同文本依据《中华人民共和国民法典》和《广西农村产权流转交易管理办法（试行）》制定的示范文本，适用于委托方委托广西捷算资产交易市场服务有限公司（以下简称“捷算公司”）主持产权交易相关事项。</p>
        <p>二、为更好地维护合同双方当事人的权益，合同当事人签订时应当慎重，力求具体、严密。对于不涉及本合同条款所述情形的事项，用“本合同不涉及此条款”表示。</p>
        <p>三、本合同所述委托标的包括：</p>
        <p>（一）农村土地承包经营权；</p>
        <p>（二）林权；</p>
        <p>（三）村、组集体荒山、荒沟、荒丘、荒滩(“四荒”)使用权；</p>
        <p>（四）农村集体经营性资产；</p>
        <p>（五）农业生产设施设备所有权；</p>
        <p>（六）不涉及公共安全的小型水利设施使用权</p>
        <p>（七）农业类知识产权；</p>
        <p>（八）涉农资产处置；</p>
        <p>（十）农村房屋使用权；</p>
        <p>（十一）生物资产所有权；</p>
        <p>（十二）村、组集体依法拥有的固定资产（不含土地）的所有权或使用权；</p>
        <p>（十三）村、组集体经济股权；</p>
        <p>（十四）农村闲置宅基地使用权；</p>
        <p>（十五）农村养殖水面承包经营权；</p>
        <p>（十六）农村集体建设项目招标；</p>
        <p>（十七）产业项目招商和转让等；</p>
        <p>（十八）其他法律没有限制的品种和服务。</p>
        <p>四、本合同所述“摘牌业务”服务一般包括：</p>
        <p>1.向委托人提供有关政策咨询；</p>
        <p>2.参与确定交易方式；</p>
        <p>3.协助交易双方成功交易；</p>
        <p>4.协助受让方以银行转账等方式支付交易价款；</p>
        <p>5.负责向捷算公司提交相关交易材料；</p>
        <p>6.根据转让标的企业制作投资分析；</p>
        <p>7.寻找转让标的，并参与谈判；</p>
        <p>8.协助办理权证变更等手续；</p>
        <p>9.其他：与产权交易有关的服务。</p>
        <p>五、委托方提交的文件：如为法人或其他组织，一般应当提供企业法人营业执照或登记证明文件、税务登记证等资信证明的复印件；如为自然人，应提供自然人的有效身份证明文件的复印件等资信证明。</p>
        <p>六、交易服务费：在捷算公司产权交易平台办理产权交易时，应支付的鉴证费用、交易佣金等，交易费标准按照《广西壮族自治区定价目录》、《广西捷算资产交易市场服务有限公司产权交易服务收费标准》、《百色市发展和改革委员会关于广西捷算资产交易市场服务有限公司产权交易服务收费标准有关问题的复函》执行。</p>
        <p>七、受托人完成委托产权交易相关服务时，委托人向受托人支付的服务费，可以以现金形式支付，也可以通过捷算公司专用账户存、汇款。</p>
        <p>八、合同涉及的当事人概况：如涉及的自然人，请在当事人概况中填写姓名及身份证号码。</p>
        <h3>委托人（以下简称甲方）：{{contractData.mainPartIdentityName}}</h3>
        <h3>受托人（以下简称乙方）：<span>广西捷算资产交易市场服务有限公司</span></h3>
        <p>甲方拟在乙方农产权交易平台挂牌，按自愿、平等、诚实、信用的原则，经甲、乙方协商一致，签订如下委托合同。</p>
        <h3>第一条  委托事项</h3>
        <p>1.标的的名称、规格、数量和价格:</p>
        <p>名称:{{contractData.name}} </p>
        <p>规格:{{contractData.holdAreaUnit}}</p>
        <p>数量:{{contractData.holdArea}}</p>
        <p>单价: {{contractData.unitPrice}} (以市场进价或批发价为准)</p>
        <p>总价: {{contractData.amount}}</p>
        <p>合计人民币金额(大写):{{digitUppercase(contractData.amount)}}</p>
        <p>2.甲方委托乙方主持上述标的摘牌、交易鉴证。</p>
        <h3>第二条  提交的文件</h3>
        <p>甲方应根据《广西农村产权流转交易管理办法（试行）》的规定，向乙方提供为完成委托事项所要求的所有相关文件材料。所提供文件为复印件的，甲方应加盖公司（企业）公章或签名确认。</p>
        <h3>第三条  权利和义务</h3>
        <p>1.甲、乙双方须遵守国家有关法律、法规、规章及《广西农村产权流转交易管理办法（试行）》的有关规定，自觉接受政府主管部门的监管。</p>
        <p>2.甲方应如实提供有关文件材料，乙方有权对有关文件材料的真实性、合法性进行审查。</p>
        <p>3.甲方有权随时向乙方了解委托事项的进展情况；乙方有义务根据甲方要求向甲方报告相关情况。</p>
        <p>4.乙方有义务按照甲方的指示处理委托事务。乙方处理委托事务时基于甲方利益考虑，认为需要甲方变更指示的，应当经甲方同意。未经甲方同意所引发的法律后果由乙方承担。</p>
        <p>5.双方均应就委托事项所提供的相关材料承担保密的义务。除非法律或有管辖权的法院、仲裁机构或行政主管机关明确要求，双方在任何情况下不得向与交易无关的第三方披露或说明本合同项下对方所提供的任何资料和文件。</p>
        <h3>第四条  双方的承诺</h3>
        <p>1.甲、乙双方承诺其所提供的所有材料（包括原件、复印件）真实、完整、 有效。</p>
        <p>2.甲方保证其委托乙方处理本合同所述委托事项已获得甲方有关机构的批准。</p>
        <p>3.除非甲方按照本合同第七条解除本合同，甲方在本合同期限内保证不再与第三方订立同一标的物受让委托合同，并不与转让人私下接触、洽谈成交。</p>
        <p>4.除非甲方按照本合同第七条解除本合同，甲方在本合同期限内保证不再与第三方订立同一标的物受让委托合同；甲方保证在乙方挂牌期间和摘牌后90日内不与任何一个转让意向方私下接触、洽谈成交。</p>
        <p>5.乙方保证其已具备从事甲方委托事项的所有资格及资质。</p>
        <h3>第五条  交易服务费及支付方式</h3>
        <p>1.交易服务费依据《广西壮族自治区定价目录》、《广西捷算惠城农村产权交易服务有限公司产权交易服务收费标准》、《百色市发展和改革委员会关于广西捷算惠城农村产权交易服务有限公司产权交易服务收费标准有关问题的复函》，由乙方负责办理。</p>
        <p>2.甲方在乙方平台办理产权交易所应支付的交易费标准按照《广西捷算惠城农村产权交易市场服务有限公司产权交易服务收费标准（试行）》执行。甲方委托乙方挂牌交易服务事宜，并通过乙方平台协助办理收款、支付、结算事宜。</p>
        <p>3.根据本合同第一条第二项约定的交易项目，甲乙双方约定，交易服务费支付金额及方式如下：</p>
        <p>（一）本次委托事项收取交易服务费为成交额{{contractData.serviceRate}}%；本次挂牌标的达成交易后甲方应于成交之日起十个工作日内向乙方支付交易服务费用。</p>
        <p>（二）通过广西捷算惠城农村产权交易服务有限公司专用账户存、汇款。</p>
        <p>户名：广西捷算惠城农村产权交易服务有限公司</p>
        <p>开户行：中国农业银行股份有限公司百色右江支行</p>
        <p>账号：20607001 0400 2074 0</p>
        <p>4.甲方须向任何第三方支付的费用，包括清产核资、实地考察、审计、评 估、权证变更等相关费用，由甲方自行承担。</p>
        <p>5.如需交纳竞价保证金或项目信誉保证金的，由甲方承担费用。</p>
        <h3>第六条  合同的期限</h3>
        <p>本合同有效期：至{{contractValidity}}。</p>
        <h3>第七条  合同的变更和解除</h3>
        <p>1.甲乙双方经协商一致可以书面形式对本合同条款进行变更，任何一方不得单方面变更本合同条款。</p>
        <p>2.甲乙双方经协商一致可以解除本合同。任何一方单方面解除本合同的，应承担由此而给对方造成的损失。</p>
        <p>3.任何一方按照本条第二款的规定解除本合同的，应向对方支付相应的费用。具体费用应按照受托方已完成委托事项的情况、或委托方因受托方解除合同导致委托事项成本加大的情况而确定。</p>
        <h3>第八条  违约责任</h3>
        <p>1.甲乙双方严格遵守法律法规的规定及本合同约定，若违反法律法规的规定和本合同，违约方应承担相应的法律责任。</p>
        <p>2.甲乙双方违反本合同第三条、第四条的规定，给对方造成损失的，应由违约方承担赔偿责任。</p>
        <p>3.甲方违反本合同第四条第五项规定，在乙方平台挂牌期间和摘牌后90日内与受让意向方私下成交的，乙方有权要求甲方赔偿因此而遭受的损失，并有权向甲方追缴金额为转让产权总价2%的违约金。</p>
        <p>4. 甲方如不按本合同约定付款，乙方有权收取应付款千分之一每天的违约金。</p>
        <h3>第九条  争议处理</h3>
        <p>合同双方在履行过程中发生争议，应本着友好合作的原则协商解决；自行协商无效时，可由百色市正捷金融纠纷调解中心调解；调解不成的，任何一方均可依法向乙方所在地百色市右江区人民法院起诉，诉讼期间所产生包括但不限于律师费、诉讼费、差旅费等均有违约方自行承担。</p>
        <h3>第十条合同的效力</h3>
        <p>本合同经甲乙双方签字盖章后生效。</p>
        <h3>第十一条  其他约定</h3>
        <h3>第十二条  本合同一式贰份，甲、乙双方各执壹份。</h3>
        <h3>委托人（甲方）：{{contractData.mainPartIdentityName}}</h3>
        <h3>电话：{{contractData.mainPartContactNumber}}</h3>
        <h3>受托人（乙方）：广西捷算资产交易市场服务有限公司</h3>
        <h3>电话：0776-2802868</h3>
        <h3>签约地点：广西捷算资产交易市场服务有限公司</h3>
        <h3>签约日期：{{contractData.createDate}}</h3>
      </div>
       <span slot="footer" class="dialog-footer">
         <div class="agree-box">
           <el-checkbox v-model="checked"></el-checkbox>
           我已阅读知晓，并接受合同中内容
         </div>
         <div class="btn-box">
           <el-button @click="visible = false">取 消</el-button>
           <el-button type="primary" @click="handleSubmit">确认挂牌</el-button>
         </div>
    </span>
  </el-dialog>
</template>

<script>
import publicFunction from '@/utils/publicFunction'
export default {
  props: {
    contractData: {
      type: Object,
      default:()=> {
        return {
          name:'',
          holdAreaUnit: '',
          holdArea: '',
          unitPrice: '',
          amount: '',
          serviceRate: '',
          mainPartIdentityName: '',
          createDate: '',
          mainPartContactNumber: '',
        }
      }
    }
  },
  data() {
    return {
      visible: false,
      contractValidity: '',//合同有效期
      checked: false,
      years: null
    }
  },
  methods: {
    digitUppercase: publicFunction.digitUppercase,
    handleClose(){
      this.$parent.isShowContract = false
    },
    handleSubmit(){
      if(!this.checked){
        return this.$message.error('请阅读知晓，并接受合同中内容')
      }
      this.visible = false
      this.$emit('listing',{
        equityTransaction: {
          name: this.contractData.mainPartIdentityName,
          phone: this.contractData.mainPartContactNumber,
          listApplyName: this.contractData.name,
          holdArea: this.contractData.holdArea,
          holdAreaUnit: this.contractData.holdAreaUnit,
          amount: this.contractData.amount,
          price: this.contractData.unitPrice,
          years: this.years,
          proportion: this.contractData.serviceRate,
          capitalizeAmount: this.digitUppercase(this.contractData.amount)
        }})
    },
    //获取合同有效期限
    getContractValidity(){
      this.$api.user.getByCategoryName({ categoryName: 'contractValidity' })
      .then(res=>{
        if(res.code===1000){
          const now = new Date()
          this.years = res.data[0].key*1
          this.contractValidity = publicFunction.dateFormat(now.setFullYear(now.getFullYear()+res.data[0].key*1),'yyyy年MM月dd日')
        }
      })
    },
    init() {
      this.visible = true;
      this.getContractValidity()
    },
  }
}
</script>

<style lang="scss" scoped>
  .dialog-footer{
    text-align: center;
    .agree-box{
      text-align: left;
      margin-bottom: 20px;
      font-size: 16px;
      color: #ef5147;
    }
    .btn-box{
      margin: auto;
    }
  }
  .content{
    height: 500px;
    overflow-y: auto;
    h2{
      font-size: 20px;
      color: #394259;
      text-align: center;
      line-height: 30px;
    }
    h1{
      font-size: 24px;
      color: #394259;
      text-align: center;
      line-height: 35px;
    }
    p{
      font-size: 16px;
      color: #394259;
      line-height: 22px;
      text-align: justify;
      text-justify: inter-ideograph;
    }
  }
</style>
